import { useAuthAppStore } from "@/store/stores/authStore";

export class FinanceService {
  async getDepartmentsByComplex({ cprxServiceClientFinance, complex }) {
    var response = await this.cproxServiceClient.finance.get({
      route: "department/get-all-entities",
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: (resp) => {
        const departments = resp?.data?.Data || [];

        return departments.map((department) => ({
          Name: department.Name,
          Code: department.Code,
        }));
      },
      errorCallback: (error) => {
        console.error("Departman verisi alınırken hata oluştu:", error);
        return []; // Hata durumunda boş dizi dönüyoruz
      },
    });

    return response;

    // var response = await cprxServiceClientFinance.get({
    //   route: "/cost-center/get-all-entities",
    //   // params: params,
    //   headers: {
    //     "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex
    //   },
    //   successCallback: function (resp) {
    //     // if (resp.data.length > 0)
    //     //     _selectedJob.unitsOnTruck = resp.data;
    //   },
    //   errorCallback: function (resp) {},
    // });

    // return response;
  }

  // async getAllEntitiesPaged({ costCentreServiceClient, params }) {
  //   var response = await costCentreServiceClient.get({
  //     route: "/cost-center/get-all-entities-paged",
  //     params: params,
  //     headers: {
  //       "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
  //       Authorization: `Bearer ${useAuthAppStore().token}`,
  //     },
  //   });

  //   return response;
  // }

  // async putEntities({ client, data, successCallback, errorCallback }) {
  //   await client.put({
  //     route: "/cost-center/update-entity",
  //     headers: {
  //       "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
  //       Authorization: `Bearer ${useAuthAppStore().token}`,
  //     },
  //     data: data,
  //     successCallback: successCallback,
  //     errorCallback: errorCallback,
  //   });
  // }

  // async createEntities({ client, data, successCallback, errorCallback }) {
  //   await client.post({
  //     route: "/cost-center/create-entity",
  //     headers: {
  //       "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
  //       Authorization: `Bearer ${useAuthAppStore().token}`,
  //     },
  //     data: data,
  //     successCallback: successCallback,
  //     errorCallback: errorCallback,
  //   });
  // }

  // async deleteEntity({ client, params, successCallback, errorCallback }) {
  //   await client.delete({
  //     route: "/cost-center/delete-entity",
  //     params: params,
  //     headers: {
  //       "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
  //       Authorization: `Bearer ${useAuthAppStore().token}`,
  //     },
  //     successCallback: successCallback,
  //     errorCallback: errorCallback,
  //   });
  // }

  // async getFindCosCentersByDepartmentCode({ costCentreServiceClient, params }) {
  //   var response = await costCentreServiceClient.get({
  //     route: "/cost-center/find-cost-centers-by-department-code",
  //     params: params,
  //     headers: {
  //       "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
  //     },
  //     successCallback: function (resp) {
  //       // if (resp.data.length > 0)
  //       //     _selectedJob.unitsOnTruck = resp.data;
  //     },
  //     errorCallback: function (resp) {},
  //   });

  //   return response;
  // }

  // async getFindByUserSession({ costCentreServiceClient }) {
  //   var response = await costCentreServiceClient.get({
  //     route: "/cost-center/find-by-user-session",
  //     // params: params,
  //     headers: {
  //       "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
  //     },
  //     successCallback: function (resp) {
  //       // if (resp.data.length > 0)
  //       //     _selectedJob.unitsOnTruck = resp.data;
  //     },
  //     errorCallback: function (resp) {},
  //   });

  //   return response;
  // }

  // async getCostCenterEntityByPKey({ costCentreServiceClient, params }) {
  //   var response = await costCentreServiceClient.get({
  //     route: "/cost-center/get-entity-by-pkey",
  //     params: params,
  //     headers: {
  //       "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
  //     },
  //     successCallback: function (resp) {
  //       // if (resp.data.length > 0)
  //       //     _selectedJob.unitsOnTruck = resp.data;
  //     },
  //     errorCallback: function (resp) {},
  //   });

  //   return response;
  // }

  // async getCostCenterEntityByCode({ costCentreServiceClient, params }) {
  //   var response = await costCentreServiceClient.get({
  //     route: "/cost-center/find-cost-center-by-code",
  //     params: params,
  //     headers: {
  //       "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
  //     },
  //     successCallback: function (resp) {
  //       // if (resp.data.length > 0)
  //       //     _selectedJob.unitsOnTruck = resp.data;
  //     },
  //     errorCallback: function (resp) {},
  //   });

  //   return response;
  // }

  // async getDepartmentEntityByCode({ costCentreServiceClient, params }) {
  //   var response = await costCentreServiceClient.get({
  //     route: "/department/get-entity-by-code",
  //     params: params,
  //     headers: {
  //       "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
  //     },
  //     successCallback: function (resp) {
  //       // if (resp.data.length > 0)
  //       //     _selectedJob.unitsOnTruck = resp.data;
  //     },
  //     errorCallback: function (resp) {},
  //   });

  //   return response;
  // }

  // async getDepartments({ costCentreServiceClient }) {
  //   var response = await costCentreServiceClient.get({
  //     route: "/department/get-all-entities",
  //     headers: {
  //       "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
  //     },
  //     successCallback: function (resp) {
  //       // if (resp.data.length > 0)
  //       //     _selectedJob.unitsOnTruck = resp.data;
  //     },
  //     errorCallback: function (resp) {},
  //   });

  //   return response;
  // }
}
